import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { Image } from "react-bootstrap";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MenuIcon from "@mui/icons-material/Menu";

const Topbar = ({ setSideBarShow, sideBarShow }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const [showDropdown, setShowDropDown] = useState(false);

  return (
    <div className="topbar">
      <div className="w-100 d-flex ac-jb position-relative">
        <div
          className=""
          style={sideBarShow ? { marginLeft: "4rem" } : { marginLeft: "15rem" }}
        >
          <button
            className="border-0 p-2 rounded btn-dual"
            onClick={() => setSideBarShow(!sideBarShow)}
          >
            <MenuIcon />
          </button>
        </div>

        <div className="d-flex justify-content-end align-items-center  gap-2">
          <div className="position-relative">
            <button
              className="border-0 p-2 rounded btn-dual"
              onClick={() => setShowDropDown(!showDropdown)}
            >
              <div className="d-flex align-items-cente">
                Admin
                <ArrowDropDownIcon />{" "}
              </div>
            </button>
            {showDropdown && (
              <div className="profile_dropdown" style={{ background: "#000" }}>
                <button className="text m-0 py-2 px-3 cust-btn">Log out</button>
              </div>
            )}
          </div>
          <div>
            <button className="border-0 p-2 rounded btn-dual">
              <NotificationsIcon />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
